// Charge la base commune
import './common.js'

// Styles custom
import './scss/pages/models.detail.scss'

// Responsive Tabs
async function getRTabs () {
  import(/* webpackChunkName: "responsiveTabs" */ './js/components/responsiveTabs.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
  })
}

// MasterSlider
async function getMasterSlider () {
  import(/* webpackChunkName: "masterSlider", webpackPrefetch: true */ './js/components/masterSlider.js').then(() => {
    Waypoint.refreshAll()
  })
}

// Gallery
async function getPhotoswipe () {
  import(/* webpackChunkName: "photoswipe", webpackPrefetch: true */ './js/components/photoswipe.js').then(() => {
    Waypoint.refreshAll()
  })
}

// ModelLike
async function getModelLike ($add) {
  import(/* webpackChunkName: "modelLike" */ './js/components/modelLike.js').then(module => {
    module.modelLike.init()
    $add.trigger('click')
  })
}

// Contact Form
async function getCForm ($f) {
  import(/* webpackChunkName: "contactForm" */ './js/components/contactForm.js').then(() => {
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Image boxes
async function getModelItem () {
  import(/* webpackChunkName: "modelsItem" */ './scss/components/modelsItem.scss').then(() => {
    Waypoint.refreshAll()
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // responsive tabs
  $('#desc-tabs').waypoint(function () {
    getRTabs()
    this.destroy()
  }, {
    offset: '100%'
  })

  // gestion master slider
  const $m = $('#masterslider')
  if ($m.length) {
    $m.waypoint(function () {
      getMasterSlider()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion des galeries
  const $g = $('.gallery')
  if ($g.length) {
    $g.waypoint(function () {
      getPhotoswipe()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // boutons d'action sur le modèle détaillé
  $('#like').on('click', function () {
    getModelLike($(this))
  })
  if (typeof (googleanalytics) !== 'undefined') {
    $('#track-f').on('click', function () { // event sur bouton financement : track event google analytics
      /* global ga */
      ga('send', 'event', 'Financement modele', 'Clic')
    })
    $('#track-c, #track-c2').on('click', function () { // event sur bouton contact : track event google analytics
      ga('send', 'event', 'Contacter modele', 'Clic')
    })
    $('#track-g').on('click', function () { // event sur bouton terrain
      ga('send', 'event', 'Recherche terrain', 'Clic')
    })
  }

  // formulaire de contact
  const $f = $('form[name="cForm"]')
  $f.waypoint(function () {
    $f.load()
    getCForm($f)
    this.destroy()
  }, {
    offset: '100%'
  })

  // gestion des modèles
  const $i = $('.model-item')
  if ($i.length) {
    $i.waypoint(function () {
      getModelItem()
      this.destroy()
    }, {
      offset: '100%'
    })
  }
})
